/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProtectedBrickItem
 */
export interface ProtectedBrickItem {
    /**
     * LEGO Teilenummer
     * @type {string}
     * @memberof ProtectedBrickItem
     */
    partNumber: string;
    /**
     * Beschreibung des Steins
     * @type {string}
     * @memberof ProtectedBrickItem
     */
    description?: string;
    /**
     * Ist das Teil aktuell geschützt?
     * @type {boolean}
     * @memberof ProtectedBrickItem
     */
    _protected: boolean;
    /**
     * Details zum Schutzstatus
     * @type {string}
     * @memberof ProtectedBrickItem
     */
    protectionDetails?: string;
    /**
     * Geschmacksmuster-Nummer
     * @type {string}
     * @memberof ProtectedBrickItem
     */
    gmNumber?: string;
    /**
     * Anmeldedatum
     * @type {Date}
     * @memberof ProtectedBrickItem
     */
    filingDate?: Date;
    /**
     * Eintragungsdatum
     * @type {Date}
     * @memberof ProtectedBrickItem
     */
    registrationDate?: Date;
    /**
     * Ablaufdatum des Schutzes
     * @type {Date}
     * @memberof ProtectedBrickItem
     */
    expiryDate?: Date;
    /**
     * Aktueller Schutzstatus
     * @type {string}
     * @memberof ProtectedBrickItem
     */
    status: ProtectedBrickItemStatusEnum;
}


/**
 * @export
 */
export const ProtectedBrickItemStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type ProtectedBrickItemStatusEnum = typeof ProtectedBrickItemStatusEnum[keyof typeof ProtectedBrickItemStatusEnum];


/**
 * Check if a given object implements the ProtectedBrickItem interface.
 */
export function instanceOfProtectedBrickItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partNumber" in value;
    isInstance = isInstance && "_protected" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ProtectedBrickItemFromJSON(json: any): ProtectedBrickItem {
    return ProtectedBrickItemFromJSONTyped(json, false);
}

export function ProtectedBrickItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtectedBrickItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partNumber': json['partNumber'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        '_protected': json['protected'],
        'protectionDetails': !exists(json, 'protectionDetails') ? undefined : json['protectionDetails'],
        'gmNumber': !exists(json, 'gmNumber') ? undefined : json['gmNumber'],
        'filingDate': !exists(json, 'filingDate') ? undefined : (new Date(json['filingDate'])),
        'registrationDate': !exists(json, 'registrationDate') ? undefined : (new Date(json['registrationDate'])),
        'expiryDate': !exists(json, 'expiryDate') ? undefined : (new Date(json['expiryDate'])),
        'status': json['status'],
    };
}

export function ProtectedBrickItemToJSON(value?: ProtectedBrickItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partNumber': value.partNumber,
        'description': value.description,
        'protected': value._protected,
        'protectionDetails': value.protectionDetails,
        'gmNumber': value.gmNumber,
        'filingDate': value.filingDate === undefined ? undefined : (value.filingDate.toISOString().substring(0,10)),
        'registrationDate': value.registrationDate === undefined ? undefined : (value.registrationDate.toISOString().substring(0,10)),
        'expiryDate': value.expiryDate === undefined ? undefined : (value.expiryDate.toISOString().substring(0,10)),
        'status': value.status,
    };
}

